import { MAIN_STYLE, MAIN_STYLE_GROUPS, PRESS_EVENTS, TOGGLE_BUTTON_EVENTS } from '../shared.js'
export const btn = {
    displayName: 'Button',

    parts: {
        main: {
            label: 'Main',
            exportSuffix: '',
            order: 0,
            propertyGroups: [...MAIN_STYLE_GROUPS],
            properties: {
                ...MAIN_STYLE,
                text_color:       { type: 'color', label: 'Text color' },
                text_font:        { type: 'int', min: 8 },
                text_font_family: { type: 'string', internal: true },
                keep_circle:      { type: 'bool', internal: true },
            },
        },
    },

    properties: {
        x: { type: 'int' }, y: { type: 'int' },
        width: { type: 'int', min: 0 }, height: { type: 'int', min: 0 },
        min_width: { type: 'int', min: 0 }, min_height: { type: 'int', min: 0 },
        haspid:   { type: 'int', min: 1, max: 254, internal: true },
        parentid: { type: 'int', min: 0, max: 254, internal: true },
        enabled: { type: 'bool' }, hidden: { type: 'bool' },
        text:    { type: 'string', label: 'Text' },
        toggle:  { type: 'bool' },
        // Firmware button value: only meaningful as an ON/OFF state when the
        // button is configured as a toggle. Kept in V2 so btn ↔ switch can
        // preserve that existing firmware state without inventing one.
        val:     { type: 'int', min: 0, max: 1 },
        align:   { type: 'enum', values: ['left', 'center', 'right', 'auto'] },
        mode:    { type: 'enum', values: ['expand', 'break', 'dots', 'scroll', 'loop', 'crop'] },
        // ATTR_SWIPE dispatches to attribute_common_tag (hasp_attribute.cpp:2759-2760), storing
        // an arbitrary string tag (hasp_object.h:28) forwarded verbatim by swipe_event_handler
        // (hasp_event.cpp:426-446) — not an on/off flag, directly analogous to tag/action.
        swipe:   { type: 'string' },
        action:  { type: 'string', internal: true },
        command: { type: 'string', internal: true },
        groupid: { type: 'int', min: 0, max: 15, exportSpecial: true },
        entityid:{ type: 'string', internal: true },
        // Font Family selection — see label.js's `font` property comment for
        // the full wire-format semantics.
        font: { type: 'resource', resourceType: 'font', label: 'Font Family', inline: true },
    },

    defaults: {
        properties: {
            x: 0, y: 0, width: 100, height: 40, min_width: 50, min_height: 40,
            enabled: true, hidden: false,
            text: '', groupid: '',
            toggle: false,
            val: 0,
            mode: 'expand',
            align: 'center',
            font: '',
        },
        styles: {
            // Real theme values (lv_theme_hasp.c: styles->btn, lines 361-433). Only the static
            // numeric literals are captured here — bg_color/border_color/text_color are
            // theme-computed (COLOR_BTN et al.), not single firmware constants, and every bundled
            // theme (hasp-dark/light, material-dark/light, mono) already overrides all of
            // main's MAIN_STYLE properties including radius, so this fallback has no visible
            // effect on any currently themed button — verified via StyleResolver's cascade
            // (schema default < theme < local < state) and every bundled themes/*/btn.js.
            main: {
                radius: 13,       // LV_DPI / 12 = 160 / 12 (integer division), lv_theme_hasp.c:362
                bg_opa: 255,      // LV_OPA_COVER, lv_theme_hasp.c:363
                border_width: 2,  // BORDER_WIDTH = HASP_DPX(2), lv_theme_hasp.c:81,386
            },
        },
    },
    states: ['checked', 'pressed', 'pressedChecked', 'disabled', 'disabledChecked'],
    editorCapabilities:  ['can_transform', 'can_copy', 'has_objectmenu'],
    runtimeCapabilities: ['has_action', 'has_group'],

    convertTo: ['label', 'switch','checkbox'],

    events: PRESS_EVENTS,
    // A toggle button runs the firmware toggle handler instead of the generic one.
    eventVariants: [{ when: { toggle: true }, events: TOGGLE_BUTTON_EVENTS }],

    bindings: {
        properties: {
            x: {}, y: {}, w: {}, h: {},
            border_width: {}, radius: {}, bg_color: {}, border_color: {},
            text_font: {}, text: {}, val: {}, text_color: {},
            shadow_width: {}, shadow_color: {}, shadow_ofs_x: {}, shadow_ofs_y: {},
            outline_width: {}, outline_color: {}, outline_pad: {},
        },
        actions: { hass_services: ['', 'homeassistant', 'openhasp', 'automation', 'climate', 'light', 'switch', 'scene', 'esphome'] },
    },

    automation: {
        runtimeVariables: [
            { name: 'val', type: 'int', label: 'Button Value (0–1)' },
        ],
        actionDomains: ['homeassistant', 'light', 'switch', 'scene', 'automation', 'climate', 'openhasp', 'esphome'],
    },
}
